import React, { Component } from "react"
import _ from "lodash"
import * as strings from "../../strings"
import * as utils from "../../utils"
import Query from "../../components/Query"
import Card from "../../components/Card"
import Division from "../../components/Division"
import LabeledValue from "../../components/LabeledValue"
import BigList from "../../components/BigList"
import SingleFileUpload from "./SingleFileUpload"
import { withActions } from "../../utils"
import style from "./style.css"

const PROCESS_COLUMNS = [
  { title: strings.processes.processType, key: "activeOption.type.name" },
  { title: strings.generalStrings.state, key: "activeOption.state.name" },
  { title: strings.generalStrings.idc, key: "idc" },
  { title: strings.processes.injunctionNumber, key: "injunctionNumber" },
]

class LotView extends Component {
  props: {
    actions: any,
    history: any,
    match: {
      path: string,
      params: {
        lotId: string,
      },
    },
  }


  renderHeader ( lot ) {
    const lotInfo = [
      { label: strings.generalStrings.client, value: _.get( lot, "client.contact.name" ) },
      { label: strings.generalStrings.lawyer, value: _.get( lot, "lawyer.contact.name" ) },
      { label: strings.lot.importReference, value: _.get( lot, "importReference" ) },
      { label: strings.lot.externalReference, value: _.get( lot, "externalReference" ) },
      { label: strings.generalStrings.receptionDate, value: utils.formatDate( _.get( lot, "receivedDate" ) ) },
      { label: strings.lot.lawyerDeliveryDate, value: utils.formatDate( _.get( lot, "lawyerDeliveryDate" ) ) },
    ]

    return (
      <Card>
        <Division title="Lote" />
        <div className={style.headerGrid}>
          {lotInfo.map( ( cell, i ) => (
            <LabeledValue key={i} label={cell.label}>{cell.value}</LabeledValue>
          ) )}
        </div>
      </Card>
    )
  }

  renderLotDocuments ( lot ) {
    return (
      <Card className={style.lotDocuments}>
        <SingleFileUpload
          label="Ficheiro Importação"
          uploadCommand="lotAddImportFile"
          downloadCommand="lotGetImportFile"
          args={{ id: lot.id }}
          file={_.get( lot, "importFile.file" )}
        />
        <SingleFileUpload
          label="Comprovativo de entrega CITIUS"
          uploadCommand="lotAddCitiusReceipt"
          downloadCommand="lotGetCitiusReceipt"
          args={{ id: lot.id }}
          file={_.get( lot, "citiusReceiptFile" )}
        />
      </Card>
    )
  }

  renderProcessList ( lot ) {
    const processes = [
      ...lot.preLitigations.map( item => ( {
        ...item,
        _onClick: () => this.props.history.push( "/preLitigations/" + item.id ),
      } ) ),
      ...lot.litigations.map( item => ( {
        ...item,
        _onClick: () => this.props.history.push( "/litigation/" + item.id ),
      } ) ),
    ]

    return (
      <BigList
        loadMore={() => {}}
        hasMoreItems={ () => false }
        items={processes}
        columns={PROCESS_COLUMNS}
      />
    )
  }

  render () {
    return (
      <Query
        query={this.props.actions.getLotById}
        args={_.parseInt( this.props.match.params.lotId )}
      >
        {( { response } ) => {
          const lot = response && response.result
          return (
            <div className={style.root}>
              {this.renderHeader( lot )}
              {this.renderLotDocuments( lot )}
              {this.renderProcessList( lot )}
            </div>
          )
        }}
      </Query>
    )
  }
}

export default withActions( LotView )



// WEBPACK FOOTER //
// ./src/views/LotView/index.jsx